import './Stars.css';

function Stars({ rating, max = 5 }) {
  return (
    <span className="stars" aria-label={`${rating} out of ${max} stars`}>
      {Array.from({ length: max }, (_, i) => {
        const full = i + 1 <= rating;
        const half = !full && i + 0.5 <= rating;
        return (
          <span key={i} className="star-wrap">
            <span className="star star-empty">★</span>
            {(full || half) && (
              <span className="star star-filled" style={{ width: full ? '100%' : '50%' }}>★</span>
            )}
          </span>
        );
      })}
    </span>
  );
}

export default Stars;
